import { trackCdp, trackEvent, trackGA } from 'utilities/tracking';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.PosKits.init());

Sq.Shop.PosKits = {
  utils: Sq.Shop.Utils,
  pageId: '#pos-kits-page',

  init() {
    if ($(this.pageId).length === 0) {
      return;
    }

    this.getHtml();
    this.loadData();
    this.bindEvents();
    this.onPageView();
  },

  getHtml() {
    this.$page = $(this.pageId);
    this.$categorySelect = $('#kit-categories');
  },

  // arrange kit elements for selected category on page load
  loadData() {
    $(document).ready(() => {
      this.categoryKitMap = JSON.parse(
        $('#kit-container').attr('data-kit-category-products-map')
      );

      if (this.$categorySelect.length > 0) {
        const selectedCategory = this.$categorySelect.val();
        $(`.results#${selectedCategory}`).removeClass('hidden');
        this.$categorySelect.data('pre', selectedCategory);
      }
      this.filterByParams();
    });
  },

  bindEvents() {
    this.$page.on('click', `[${this.utils.PRODUCT_DATA_ATTR}]`, (e) =>
      this.onProductClick(e)
    );
    this.$categorySelect.on('change', () => this.filterProducts());
  },

  filterByParams() {
    const filterSearch = new URLSearchParams(window.location.search).get(
      'filter'
    );
    if (
      filterSearch &&
      this.$categorySelect.find(`option[value="${filterSearch}"]`).length > 0
    ) {
      this.$categorySelect.val(filterSearch);
      this.filterProducts();
    } else {
      this.displayKitsForCategory('all');
    }
  },

  filterProducts() {
    const previousCategory = this.$categorySelect.data('pre');
    const selectedCategory = this.$categorySelect.val();

    // update URL without reloading to allow link with filter applied
    window.history.replaceState(null, '', `?filter=${selectedCategory}`);

    $(`.results#${previousCategory}`).addClass('hidden');
    $(`.results#${selectedCategory}`).removeClass('hidden');

    this.$categorySelect.data('pre', selectedCategory);
    this.displayKitsForCategory(selectedCategory);
  },

  displayKitsForCategory(selectedCategory) {
    $('#kit-container .kit-product').addClass('hidden');
    // for each kit under the category,
    // the kit element will be removed and append to the end of the list
    // based on the order of product_key values
    const kitSlugs = this.categoryKitMap[selectedCategory];
    kitSlugs.forEach((slug) => {
      const $kitElem = $(`#${slug}`);
      $kitElem.removeClass('hidden');
      $kitElem.remove();
      $kitElem.appendTo('#kit-container');
    });
  },

  onPageView() {
    // Track
    this.utils.trackProductList(this.$page, {
      listName: 'Kits',
      impression: true,
    });
  },

  onProductClick(e) {
    const product = this.utils.productData(e.currentTarget);
    product.list = 'Kits';

    trackGA('ec:addProduct', product);
    trackGA('ec:setAction', 'click', { list: 'Kits' });
    trackEvent({
      name: 'Product',
      value: 'Click',
      params: product,
    });
    trackCdp({
      name: 'Click Product',
      params: {
        feature: 'shop',
        sku: product.sku,
      },
    });
  },
};
